// extracted by mini-css-extract-plugin
export var bottomBar = "Footer-module--bottomBar--84fe4";
export var bottomCopy = "Footer-module--bottomCopy--c1a70";
export var bottomLogo = "Footer-module--bottomLogo--8e447";
export var city = "Footer-module--city--c43db";
export var cityName = "Footer-module--cityName--517fe";
export var cityTime = "Footer-module--cityTime--b45a3";
export var column = "Footer-module--column--aa0eb";
export var columnItem = "Footer-module--columnItem--fcda4";
export var columnTitle = "Footer-module--columnTitle--80130";
export var contact = "Footer-module--contact--03804";
export var contactAddress = "Footer-module--contactAddress--1ab72";
export var contactCallToActionButton = "Footer-module--contactCallToActionButton--ae04e";
export var contactColumn = "Footer-module--contactColumn--ea78c";
export var contactFormParent = "Footer-module--contactFormParent--55ac7";
export var contactFormWrapper = "Footer-module--contactFormWrapper--5abb5";
export var contactLink = "Footer-module--contactLink--394e8";
export var contactLinkList = "Footer-module--contactLinkList--37fd4";
export var contactUs = "Footer-module--contactUs--a4b4f";
export var fact = "Footer-module--fact--e2478";
export var factHightlight = "Footer-module--factHightlight--73098";
export var factIntro = "Footer-module--factIntro--088b6";
export var menu = "Footer-module--menu--8814e";
export var root = "Footer-module--root--93a12";
export var whereWeAre = "Footer-module--whereWeAre--8b33e";